import emailjs from 'emailjs-com';
import { motion } from 'framer-motion';
import React, { useRef, useState } from 'react';

const Contact = () => {
    const form = useRef();
    const [note, setNote] = useState('');

    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    const sendEmail = (e) => {
        e.preventDefault();
        setNote(' Sending...');

        emailjs
            .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
            .then(
                () => {
                    setNote(' Message sent successfully. Thank you! I will reply soon.');
                    form.current.reset();
                },
                (error) => {
                    console.error(error.text);
                    setNote(' Something went wrong. Please try again later.');
                }
            );
    };

    return (
        <section id="contact" className="my-5">
            {/* Animated Heading */}
            <motion.h3
                className="text-center mb-4"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
            >
                Contact Me
            </motion.h3>

            {/* Animated Form Card */}
            <motion.div
                className="card-portfolio p-4 mt-3 shadow-lg rounded"
                style={{ backgroundColor: '#1e283c', color: 'white' }}
                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
            >
                <form ref={form} onSubmit={sendEmail}>
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input name="from_name" className="form-control" placeholder="Your Name" required />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input name="reply_to" className="form-control" type="email" placeholder="you@example.com" required />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Message</label>
                        <textarea name="message" className="form-control" rows="5" placeholder="Write your message..." required></textarea>
                    </div>

                    {/* Animated Button */}
                    <motion.button
                        className="btn btn-color w-100"
                        type="submit"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        Send Message
                    </motion.button>

                    <div id="form-note" className="mt-3 text-center">{note}</div>
                </form>
            </motion.div>
        </section>
    );
};

export default Contact;
